import React from 'react';
import { TicketStatus } from '../../../entities/ticket/model/types';
import * as S from './StatusModal.styles';

interface StatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (status: TicketStatus) => void;
  currentStatus?: TicketStatus;
  hasCategory: boolean;
}

const statusOptions: Array<{ value: TicketStatus; label: string; requiresCategory: boolean }> = [
  { value: 'new', label: 'Новый', requiresCategory: false },
  { value: 'active', label: 'Открыто', requiresCategory: false },
  { value: 'waiting_info', label: 'Ожидаем ответ клиента', requiresCategory: false },
  { value: 'in_programming', label: 'В программирование', requiresCategory: false },
  { value: 'resolved', label: 'Решено', requiresCategory: true },
  { value: 'closed', label: 'Закрыто', requiresCategory: true },
  { value: 'spam', label: 'Спам', requiresCategory: true },
  { value: 'duplicate', label: 'Дубликат', requiresCategory: true },
];

export const StatusModal: React.FC<StatusModalProps> = ({
  isOpen,
  onClose,
  onSelect,
  currentStatus,
  hasCategory,
}) => {
  const handleSelect = (status: TicketStatus) => {
    const option = statusOptions.find(opt => opt.value === status);
    if (option?.requiresCategory && !hasCategory) {
      alert('Для этого статуса необходимо выбрать категорию');
      return;
    }
    onSelect(status);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <S.ModalOverlay onClick={onClose}>
      <S.ModalContent onClick={(e) => e.stopPropagation()}>
        <S.ModalHeader>
          <S.ModalTitle>Выберите статус</S.ModalTitle>
          <S.CloseButton onClick={onClose}>×</S.CloseButton>
        </S.ModalHeader>

        <S.StatusList>
          {statusOptions.map(option => {
            const isDisabled = option.requiresCategory && !hasCategory;
            return (
              <S.StatusItem
                key={option.value}
                $selected={currentStatus === option.value}
                $disabled={isDisabled}
                onClick={() => !isDisabled && handleSelect(option.value)}
                title={isDisabled ? 'Необходимо выбрать категорию' : ''}
              >
                {option.label}
                {isDisabled && <S.DisabledHint>Требуется категория</S.DisabledHint>}
              </S.StatusItem>
            );
          })}
        </S.StatusList>
      </S.ModalContent>
    </S.ModalOverlay>
  );
};


